module.exports = __webpack_public_path__ + "static/img/All-Nations.548623e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/All-Nations.jpg
// module id = 57TE
// module chunks = 0